
import AppInfo from '@/util/AppInfo'
import { computed, defineComponent, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import useValidateForAccess from '@/Hooks/useValidateForAccess'

export default defineComponent({
  name: 'MailAddressChangeCompletePage',
  setup() {
    const { t } = useI18n()
    onMounted(() => {
      useValidateForAccess('MailAddressChangeStore', ['tokenId'], 'ErrorPage')
    })
    const fluxLoginUrl = computed(() => {
      const appType = AppInfo.isSmartPhone ? 'flsp' : 'fl'
      return `${process.env.VUE_APP_FLUX_LOGIN_PAGE_BASE_URL}/${appType}/index.html#/login`
    })
    return {
      t,
      fluxLoginUrl,
    }
  },
  components: {},
})
